module.exports = __webpack_public_path__ + "geoCompass.7321b414f10bf65e7447bda79b352220.png";